import { inject, Injectable } from '@angular/core'
import { _stringify, AppError } from '@naturalcycles/js-lib'
import { ErrorComponent } from '@src/app/components/error/error.component.js'
import { logger } from '../util/log.util.js'
import { ModalService } from './modal.service.js'

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private modalService = inject(ModalService)

  getErrorMessage(err: any): string {
    if (err instanceof AppError) {
      if (err.data.userFriendly) {
        return err.message
      }

      if (err.cause?.data.userFriendly) {
        return err.cause.message
      }
    }

    return _stringify(err)
  }

  logError(err: any): void {
    const errTxt = this.getErrorMessage(err)
    logger.error(errTxt, err)
  }

  async showErrorDialog(err: any): Promise<void> {
    this.logError(err)

    return await this.modalService.show({
      component: ErrorComponent,
      api: {
        error: this.getErrorMessage(err),
      },
    })
  }
}
